export abstract class EnvironmentBase {
  public production = false;
  public api = '//localhost:7777';
  public wsApi = 'ws://localhost:7777';
  public readonly paymentMinValue = 100;

  constructor() {
    const {api, wsApi} = this.generateApiHostname();
    this.api = api;
    this.wsApi = wsApi;
  }

  private generateApiHostname() {
    const baseHref = new URL(document.baseURI);

    if (baseHref.pathname === '/') {
      var parts = baseHref.host.split('.')
      // for local testing special case
      if (parts[0] === 'testpanel') {
        parts.shift()
        return {
          api: `${ baseHref.protocol }//testapi.${ parts.join('.') }`,
          wsApi: `${ baseHref.protocol.includes('https') ? 'wss' : 'ws' }://testapi.${ parts.join('.') }`
        };
      }

      return {
        api: `${ baseHref.protocol }//api.${ baseHref.host }`,
        wsApi: `${ baseHref.protocol.includes('https') ? 'wss' : 'ws' }://api.${ baseHref.host }`
      };
    }

    return {
      api: `${ baseHref.protocol }//${ baseHref.host }/api`,
      wsApi: `${ baseHref.protocol.includes('https') ? 'wss' : 'ws' }://${ baseHref.host }/api`
    };
  }
}
